module.exports = "<app-backendsettings [settings]=false [is_dashboard]=true  [subview]='subview'></app-backendsettings>\r\n"